<template>
    <div v-if="!requisicoes.finalizado" class="loading-overlay">
        <div class="spinner"></div>
    </div>
    <div v-if="requisicoes.finalizado" class="containerRepresentante">
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
         </div>

         <div class="formulario">

           <div class="titleForm" style="display: inline-flex">
              <div style="width: 90%">

              <LabelDisclaimer :TamanhoFonteLabel="'H3'" :NomeLabel="'Procuradores'" :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'" :SubSessao="'Procuradores'"/>

              <h5>Clique em adicionar se possuir procuradores. Você pode adicionar quantas pessoas desejar.</h5>
              </div>

           </div>
           <div class="resumoForm">
            <div class="opcoesForm" v-if="listaRepresentantes.length == 0">
                <img src="@/assets/addRepresentante.png" />
                <h3>Nenhuma pessoa adicionada</h3>
                <h5>Você pode adicionar mais de um tipo e quantas pessoas desejar</h5>
            </div>
            <div v-if="listaRepresentantes.length > 0">
              <table class="table">
                <thead>
                  <th style="width: 20%">Nome e E-mail</th>
                  <th style="width: 15%">CPF/CNPJ</th>
                  <th style="width: 20%">Emissor de Ordem</th>
                  <th style="width: 20%">US Person</th>
                  <th style="width: 20%">Politicamente exposta</th>
                  <th style="width: 20%">&nbsp;</th>
                </thead>
                <tbody>
                  <tr v-for="(representanteObj, index) in listaRepresentantes" :key="index">
                    <td><span class="destaque">{{representanteObj.Nome}} </span> {{representanteObj.Email}}</td>
                    <td>{{formatCpfCnpj(representanteObj.Cpf)}}</td>
                    <td>{{representanteObj.EmissorOrdem == true ? "Sim" : "Não"}}</td>
                    <td>{{representanteObj.UsPerson == true ? "Sim" : "Não"}}</td>
                    <td>{{representanteObj.PoliticamenteExposta == true ? "Sim" : "Não"}}</td>
                    <td>
                      
                     <div class="widget icons" style="display: inline-flex">

                                        <a
                                            @click.stop.prevent="
                                                editarRepresentante(index)
                                            "
                                            class="ico__edit"
                                            title="editar"                                            
                                        >
                                            <Icon icon="ico-edit" />
                                            
                                        </a>

                                     <a v-if="politicaSelecionada == null || (politicaSelecionada != null && politicaSelecionada.guid == item.guid)"
                                        @click.stop.prevent="deletarRepresentante(index)"
                                        class="ico__delete"
                                        title="deletar"    
                                        style="margin-left: 5px" 
                                    >
                                    </a>
                                     </div>


                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
           </div>


         </div>
         <div class="formulario">


              <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">

                  <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados procurador'" :TipoCliente="'Pessoa Física'" :Sessao="'Representantes'" :SubSessao="'Representantes'"/>

                </div>
                <div class="camposAgrupamentoFormulario">

                  <div class="row">
                    <div class="label__field" style="width: 60%">
                      <label class="label" for="nome">Nome*</label>
                      <input class="field" type="text" id="nome"   v-model="representante.Nome">
                    </div>

                    <div class="label__field" style="width: 40%">
                      <label class="label" for="cpf">CPF/CNPJ*</label>
                      <input  class="field" type="text" id="cpf"   v-model="representante.Cpf">
                    </div>

                  </div>

                  <div class="row">
                    <div class="label__field" style="width: 40%">
                      <label class="label" for="nome">E-mail*</label>
                      <input class="field" type="text" id="email"   v-model="representante.Email">
                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="cpf">Cargo</label>
                      <input  class="field" type="text" id="cargo"   v-model="representante.Cargo">
                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="cpf">Telefone*</label>
                      <input  class="field" type="text" :v-mask="celularMask"  id="telefone"   v-model="representante.Telefone">


                    </div>

                  </div>

                  <div class="row">
                    <div class="label__field" style="width: 40%">
                      <label class="label" for="nome">CEP*</label>
                      <input class="field" type="text" id="cep" v-model="representante.Cep" @change="validarCep">
                    </div>

                    <div class="label__field" style="width: 40%">
                      <label class="label" for="cpf">Endereço/Logradouro</label>
                      <input  class="field" type="text" :disabled="isDisabledEndereco" id="logradouro"   v-model="representante.Logradouro">
                    </div>

                    <div class="label__field" style="width: 20%">
                      <label class="label" for="cpf">Número*</label>
                      <input  class="field" type="text" id="numero"   v-model="representante.Numero">
                    </div>

                  </div>



                  <div class="row">
                    <div class="label__field" style="width: 40%">
                      <label class="label" for="nome">Complemento</label>
                      <input class="field" type="text" id="complemento"   v-model="representante.Complemento">
                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="cpf">Bairro</label>
                      <input  class="field" :disabled="isDisabledEndereco"  type="text" id="bairro"   v-model="representante.Bairro">
                    </div>

                    <div class="label__field" style="width: 30%">
                      <label class="label" for="cpf">Cidade*</label>
                      <input  class="field" :disabled="isDisabledEndereco" type="text" id="cidade"   v-model="representante.Cidade">
                    </div>

                  </div>

                  
                  <div class="row">
                    <div class="label__field" style="width: 20%">
                      <label class="label" for="nome">UF*</label>
                      <input class="field" :disabled="isDisabledEndereco" type="text" id="uf"   v-model="representante.Uf">
                    </div>

                    <div class="label__field" style="width: 20%">
                      <label class="label" for="cpf">País</label>
                      <input  class="field" :disabled="isDisabledEndereco" type="text" id="pais"   v-model="representante.Pais">
                    </div>

                    <div class="label__field" style="width: 20%">
                     <div class="form__controls" style="width: 100%">
                      <label class="label" for="nome">Será emissor de ordem?*</label>
                      <div class="radio">
                                            <input
                                                type="radio"
                                                id="false"
                                                name="EmissorOrdem"
                                                class="field__radio"
                                                value="false"
                                                v-model="representante.EmissorOrdem"
                                            />
                                            <label
                                                for="Nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                                type="radio"
                                                id="true"
                                                value="true"
                                                name="EmissorOrdem"
                                                class="field__radio field__radio_second"
                                                 
                                                v-model="representante.EmissorOrdem"
                                            />
                                            <label
                                                for="Sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>

                                        </div>
                    </div>
                    </div>


                                        <div class="label__field" style="width: 20%">
                     <div class="form__controls" style="width: 100%">
                      <label class="label" for="nome">Considerado US Person?*</label>
                      <div class="radio">
                                            <input
                                                type="radio"
                                                id="false"
                                                name="UsPerson"
                                                class="field__radio"
                                                value="false"
                                                 
                                                v-model="representante.UsPerson"
                                            />
                                            <label
                                                for="Nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                                type="radio"
                                                id="true"
                                                value="true"
                                                name="UsPerson"
                                                class="field__radio field__radio_second"
                                                 
                                                v-model="representante.UsPerson"
                                            />
                                            <label
                                                for="Sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>

                                        </div>
                    </div>
                    </div>


                    <div class="label__field" style="width: 20%">
                     <div class="form__controls" style="width: 100%">
                      <label class="label" for="nome">Politicamente Exposto?*</label>
                      <div class="radio">
                                            <input
                                                type="radio"
                                                id="false"
                                                name="PoliticamenteExposta"
                                                class="field__radio"
                                                value="false"
                                                 
                                                v-model="representante.PoliticamenteExposta"
                                            />
                                            <label
                                                for="Nao"
                                                class="label__radio"
                                            >
                                                Não
                                            </label>

                                            <input
                                                type="radio"
                                                id="true"
                                                value="true"
                                                name="PoliticamenteExposta"
                                                class="field__radio field__radio_second"
                                                 
                                                v-model="representante.PoliticamenteExposta"
                                            />
                                            <label
                                                for="Sim"
                                                class="label__radio"
                                            >
                                                Sim
                                            </label>

                                        </div>
                    </div>
                    </div>

                  </div>


                                <div class="buttonsAcoes" style="margin-bottom: 10px;">         
                                                                        <button                                    
                                            class="btnDefault"
                                            type="button"
                                            style="width: 80px; height: 40px;"
                                            @click="limparRepresentante"
                                        >
                                            Cancelar
                                        </button>                                 
                                    <button                                    
                                            class="btnBlue"
                                            type="button"
                                            v-if="representante.Guid == ''"
                                            :disabled="disableBtnSalvarRepresentante"
                                            @click="salvarAlteracoesLocalmenteRepresentante"
                                        >
                                            Adicionar
                                        </button>       

                                    <button                                    
                                            class="btnBlue"
                                            type="button"
                                            v-if="representante.Guid != ''"
                                            :disabled="disableBtnSalvarRepresentante"
                                            @click="salvarAlteracoesLocalmenteRepresentante"
                                        >
                                            Atualizar
                                        </button>    


                                </div>

                </div>
              </div>

         </div>

          <div class="footerFormulario">

            <div class="buttonsAcoes">
              <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao != true">Salvar e continuar depois</button>
              <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao == true">Salvar</button>
              <button class="btnBlue" v-if="!Edicao"  @click="proximaEtapa">Avançar</button>
            </div>

          </div>

           <ModalAddPessoa />

    </div>

    
</template>


<script>

import viacep from '@/api/viacep';
import { mapGetters } from 'vuex';
import ModalAddPessoa from './ModalAddPessoa.vue'
import formatCpfCnpj from '@/utils/formatCpfCnpj'
import LabelDisclaimer  from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'
import api from '@/api/axios';

export default {
    name: 'CadastroPF_Representantes',
    props: ['Edicao'],
    mixins: [formatCpfCnpj],
    components: { ModalAddPessoa, LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaRepresentantes: 'GET_LISTA_REPRESENTANTES_PJ'
        }),
       celularMask() {
        const telefoneLimpo = this.representante.Telefone?.replace(/\D/g, '');

        if (telefoneLimpo?.length <= 11) {
          return '(##) #####-####'; 
        } 
        else {
          return '+(##) (##) ####-#####'; 
        }
       },
        
    },
    data() {
      return {
          disableBtnSalvarRepresentante: false,
          isDisabledEndereco: true,
          requisicoes: {
            listaRepresentantes: false,
            finalizado: false
          },
          representante: {
            Guid: '',
            ClienteId: '',
            Nome: '',
            Cpf: '',
            Email: '',
            Cargo: '',
            Telefone: '',
            Cep: '',
            Logradouro: '',
            Numero: '',
            Complemento: '',
            Bairro: '',
            Cidade: '',
            Uf: '',
            Pais: '',
            Tipo: 'Procurador',
            EmissorOrdem: false,
            UsPerson: false,
            PoliticamenteExposta: false,
          }
      }
    },
    created(){
       this.$store.dispatch('FETCH_PF_LISTA_REPRESENTANTES', this.user.ClienteId);
    },
    mounted(){
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA', false);
        this.representante.ClienteId = this.user.ClienteId;
    },
    watch: {
      listaRepresentantes(){
        this.verificarSeRequisicoesFinalizaram('listaRepresentantes');
      }
    },
    methods: {
            verificarSeRequisicoesFinalizaram(requisicao){
              if(requisicao == 'listaRepresentantes')
              {
                this.requisicoes.listaRepresentantes = true;
              }

              if(this.requisicoes.listaRepresentantes){
                this.requisicoes.finalizado = true;
              }
            },
            async validarCep() {
            var cepFormatado = this.representante.Cep.replace(/\D/g, '');
            this.representante.Cep = cepFormatado;
            if(cepFormatado.length != 8)
            {

                this.$swal({
                  icon: 'error',
                  title: 'Oops...',
                  text: `CEP informado está fora do padrão`,
                });

                this.representante.Logradouro = null;
                this.representante.Bairro = null;
                this.representante.Cidade = null;
                this.representante.Uf = null;
                this.representante.Pais = null;
                this.representante.Cep = null;

                 this.isDisabledEndereco = true; 
            }
            else
            {

                const { data } = await viacep.get(`/ws/${this.representante.Cep}/json/`);

                if (data.erro) {

                  this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `CEP informado não foi localizado, preencha os campos manualmente`,
                  });

                  this.isDisabledEndereco = false; 

              } else {

                  this.erro = false;
                  this.representante.Logradouro = data.logradouro;
                  this.representante.Bairro = data.bairro;
                  this.representante.Cidade = data.localidade;
                  this.representante.Uf = data.uf;
                  this.representante.Pais = 'Brasil';

                  if (this.representante.Logradouro === '' || this.representante.Bairro == '') {
                    this.isDisabledEndereco = false; 
                  }else{
                    this.isDisabledEndereco = true; 
                  }

              }
            }
      },
      proximaEtapa(){
        this.$store.commit('SET_ETAPA_CADASTRO', 2);
        this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
        this.salvarInformacoes();
      },
      salvarInformacoes(){
        this.$store.commit('SET_PF_SALVAR_INFO', true);
      },
      incluirPessoa(){
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA', true);
      },
      async salvarAlteracoesLocalmenteRepresentante(){
            this.disableBtnSalvarRepresentante = true;
             var encodedCredentials = btoa('sat@sat:sat23!');

                await api
                    .post('/PessoaFisica/representante', this.representante, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                          this.disableBtnSalvarRepresentante = false;
                        if(retorno.status == 200)
                        {

                          this.$swal({
                              icon: 'success',
                              title: this.representante.Guid == '' ? 'Inclusão realizada com sucesso!' : 'Alteração realizada com sucesso!',
                              text: 'Dados informados foram salvos com sucesso.',
                          });
                          this.limparRepresentante();
                          this.$store.dispatch('FETCH_PF_LISTA_REPRESENTANTES', this.user.ClienteId);

                        }
                    })
                    .catch((error) => {
                        this.disableBtnSalvarRepresentante = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos para representante',
                            text: `${error.response.data.data[0]}`,
                        });
                    });

      },
      editarRepresentante(index)
      {
        this.representante = this.listaRepresentantes[index];
      },
      limparRepresentante(){
        this.representante.Guid = '';
        this.representante.ClienteId = this.user.ClienteId;
        this.representante.Nome = '';
        this.representante.Cpf = '';
        this.representante.Email = '';
        this.representante.Cargo = '';
        this.representante.Telefone = '';
        this.representante.Cep = '';
        this.representante.Logradouro = '';
        this.representante.Numero = '';
        this.representante.Complemento = '';
        this.representante.Bairro = '';
        this.representante.Cidade = '';
        this.representante.Uf = '';
        this.representante.Pais = '';
        this.representante.Tipo = 'Procurador'; // Mantém o valor padrão
        this.representante.EmissorOrdem = false;
        this.representante.UsPerson = false;
        this.representante.PoliticamenteExposta = false;
      },
      async deletarRepresentante(index){
             this.disableBtn = true;
             var encodedCredentials = btoa('sat@sat:sat23!');

                await  api.get(`PessoaFisica/representante/excluir?guid=${this.listaRepresentantes[index].Guid}&tipo=${this.listaRepresentantes[index].Tipo}`, { headers: { 'Authorization': `Basic ${encodedCredentials}`}} )
                    .then((retorno) => {
                          
                        if(retorno.status == 200)
                        {

                          this.$swal({
                              icon: 'success',
                              title: 'Exclusão realizada com sucesso!',
                              text: 'Dados informados foram excluídos com sucesso.',
                          });

                          this.$store.dispatch('FETCH_PF_LISTA_REPRESENTANTES', this.user.ClienteId);

                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos',
                            text: `${error.response.data.data[0]}`,
                        });
                    });

        }

    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

    .btnBlueUpload{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    widows: 88px;
      cursor: pointer;
    
  }


.formulario{
  margin-top: 20px;
  width: 100%;
  margin-bottom: 10px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */
  border: 1px solid #EAECF0;
  border-radius: 8px; /* Raio de borda */


.titleForm{
  background-color: white;
  border-bottom: 1px solid #EAECF0;
  width: 100%;

    .btnBlue{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    width: 100px;
    cursor: pointer;
    
  }

    h3{
      margin-left: 20px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

    h5{
    margin-top: 5px;
    margin-left: 20px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
  }


}

.resumoForm{
  width: 100%;

.opcoesForm{
    margin-left: 30%;
    display: grid;
    justify-content: space-between;
    align-content: space-between;
    align-items: center;
    justify-items: center;
    padding: 30px 0px 30px 0px;
    
  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
  }

    img{
      height: 48px;
      width: 48px;
      
    }


  .btnBlue{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    width: 350px;
    cursor: pointer;
    
  }
}

}

}

.agrupamentoFormulario{
  width: 100%;
  display: inline-flex;
  margin-top: 10px;
}

.categoriaAgrupamentoFormulario{
  width: 13%;
  margin-right: 15px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */

  span{
    font-weight: 400 !important;
    font-size: 13px;
    color: #667085;
  }

}

.label__field{
  padding-right: 30px;
}

.camposAgrupamentoFormulario{
  width: 90%;

  .row{
    width: 100%;
    display: inline-flex;
    gap: 8px;
    margin-bottom: 10px;
  }

                  .accept {
                    display: inline-flex;

                    &:checked {
                      +label {
                            &:before {
                                background: white;
                                border: 1px solid black;
                                transition: background 0.3s;
                            }
                        }

                        +label {
                            &::after {
                                opacity: 1;
                                transition: all;
                                background: transparent;
                            }
                        }
                    }
                }



 .radio {
                display: flex;
                align-items: center;
                margin-right: 25px;

                @media (max-width: 768px) {
                    margin-right: 0;
                    margin-bottom: 20px;
                }

                .field__radio {
                    width: 20px;
                    height: 20px;
                }

                .fieldInRadio{
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: #F9FAFB; /* Cor de fundo */
    width: 55%;
                }

                .label__radio {
                    margin-left: 5px;
                    margin-right: 40px;
                    margin-top: 5px;
                }
            }

select{
  width: 105% !important;
}


label {
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    font-weight: 500; /* Peso médio */
    font-size: 14px; /* Tamanho da fonte */
    line-height: 20px; /* Altura da linha */
    color: #344054; /* Cor */
    display: block; /* Garante que a label fique acima do input */
    margin-bottom: 8px; /* Espaçamento entre a label e o input abaixo dela */
}

}





.title{

  border-bottom: 1px solid #EAECF0;

  h3{
    margin-top: 50px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
  }
}


</style>